import { Injectable } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { ValidatorFn } from '@angular/forms';
import { AbstractControl } from '@angular/forms';
import * as moment from 'moment-timezone';
import { FolderDto } from '../dtos/folderDto';

@Injectable({
    providedIn: 'root'
})
export class UtilService {

    constructor() {
    }


    patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } => {
            if (!control.value) {
                // if control is empty return no error
                return null;
            }

            // test the value of the control against the regexp supplied
            const valid = regex.test(control.value);

            // if true, return no error (no error), else return error passed in the second parameter
            return valid ? null : error;
        };
    }

    groupBy(xs, key) {
        return xs.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    };

    calculateDistanceBetweenDates(dateStart, dateEnd?){
        let countDownStart = moment(dateStart).tz('Europe/Athens').valueOf();
        const countDownEnd = dateEnd ? moment(dateEnd).tz('Europe/Athens').valueOf() : moment().tz('Europe/Athens').valueOf();
        const distance = countDownStart - countDownEnd;

        // Time calculations for days, hours, minutes and seconds
        return{
            distance: distance,
            days : Math.floor(distance / (1000 * 60 * 60 * 24)),
            hours : Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
            minutes : Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
            seconds : Math.floor((distance % (1000 * 60)) / 1000)
        }

    }

    locateParentFolder(allFolders: FolderDto, currentFolder: FolderDto): FolderDto{
        let foundFolder: FolderDto;
        if(allFolders.folderDtos.length >0){
            foundFolder = allFolders.folderDtos.findIndex((folder)=>folder.path === currentFolder.path) > -1 ? allFolders : null;
        }
        if(!foundFolder){
            for (let folderInner of allFolders.folderDtos){
                foundFolder =  this.locateParentFolder(folderInner, currentFolder);
            }
        }
        return foundFolder;
    }
}
